import useConditionalFields from './useConditionalFields.tsx';
import useGroupedFields from './useGroupedFields.tsx';
import Registry from '../flow/registry.tsx';
import { useRegistrationStore } from '../store/store.ts';
import { TField, TStep } from '../types/types.ts';

const useFieldRenderer = (fields: TField[], step: TStep) => {

  const { errors, formData, conditions, metadata } = useRegistrationStore();

  const filteredFields = useConditionalFields(fields, conditions, formData, metadata);
  const groupedFields = useGroupedFields(filteredFields);

  return groupedFields.map((group, index) => {
    if (Array.isArray(group)) {
      return (
        <div key={index} className="flex flex-row w-full gap-xs">
          {group.map((field) => (
            <div key={field.name}
              className="flex-1">
              <Registry
                field={field}
                error={errors[field.name] ? true : undefined}
                data-error={errors[field.name] ? true : undefined}
                errorMessage={errors[field.name]}
                value={formData?.[field.name] || ''}
                step={step}
              />
            </div>
          ))}
        </div>
      );
    } else {
      const field = group as TField;

      return (
        <Registry
          key={field.name}
          field={field}
          error={errors[field.name] ? true : undefined}
          data-error={errors[field.name] ? true : undefined}
          errorMessage={errors[field.name]}
          value={formData?.[field.name] || ''}
          step={step}
        />
      );
    }
  });
};

export default useFieldRenderer;
